export default "__VITE_ASSET__B_hi_KXc__"